(() => {
  // Use the store's consent-aware Shopify pixel pipeline, not a second GA tag.
  window.JMT_FALL_TRACK = function(name, data) {
    const payload = Object.assign({page_path:location.pathname,collection:'fall-thongs',currency:window.Shopify?.currency?.active || 'USD'},data);
    function send(remaining) {
      try {
        if (typeof window.Shopify?.analytics?.publish === 'function') {
          Promise.resolve(window.Shopify.analytics.publish(name,payload)).catch(()=>{});
        } else if (remaining) setTimeout(()=>send(remaining-1),250);
      } catch(e) { /* Tracking must never block shopping. */ }
    }
    send(20);
  };
  const cache = new Map();
  let product, opener, editing = false, request = 0;
  const panel = document.createElement('dialog');
  panel.id = 'jmt-fall-product';
  panel.setAttribute('aria-labelledby', 'jmt-fall-product-title');
  panel.innerHTML = '<div class="fall-product-top"><span>FALL COLLECTION</span><button type="button" data-close aria-label="Close product details">×</button></div><div class="fall-product-body"><div><img class="fall-product-image" alt="" width="700" height="700"><div class="fall-product-thumbs" aria-label="Product photos"></div></div><div><h2 id="jmt-fall-product-title">Product details</h2><p class="fall-product-price"></p><p data-status role="status"></p><div class="fall-product-fit"><p data-fit></p><button type="button" data-fit-edit>Choose or edit fit</button><button type="button" data-jmt-quickadd disabled>Add to cart</button></div><p class="fall-product-description"></p><a class="fall-product-full">View full product page →</a></div></div>';
  document.getElementById('MainContent').appendChild(panel);
  const q = s => panel.querySelector(s);
  const closeIcon = document.querySelector('#jmt-quick-fit .jmt-quick-fit__close svg');
  if (closeIcon) {
    const icon = closeIcon.cloneNode(true);
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    q('[data-close]').replaceChildren(icon);
  }
  function close() {
    ++request; editing = false; panel.close();
    document.documentElement.classList.remove('jmt-fall-product-open');
    opener?.focus({preventScroll:true});
  }
  function fit() {
    if (!product) return;
    const p = window.JMT_PREF?.get() || {};
    const values = [p.pouchStyle || p.cut, p.waistSize || p.size, p.thongStrapStyle];
    q('[data-fit]').textContent = values.every(Boolean) ? values.join(' · ') + [p.pouchAdjustment && 'Pouch ' + p.pouchAdjustment + '″', p.backStrapAdjustment && 'Back strap ' + p.backStrapAdjustment + '″'].filter(Boolean).map(x=>' · '+x).join('') : 'Choose your pouch, waist size, and back style.';
    const selections = {};
    (product.options || []).forEach(option => {
      const name = typeof option === 'string' ? option : option.name;
      const role = window.JMT_VARIANTS?.role(name);
      selections[name] = role === 'pouchStyle' ? values[0] : role === 'waistSize' ? values[1] : role === 'thongStrapStyle' ? values[2] : undefined;
    });
    const variant = values.every(Boolean) && window.JMT_VARIANTS?.findVariant(product, selections, {availableOnly:true, requireAll:true});
    const add = q('[data-jmt-quickadd]');
    add.disabled = !variant;
    add.textContent = variant ? 'Add to cart' : values.every(Boolean) ? 'Choose another fit' : 'Choose your fit first';
    const currency = window.Shopify?.currency?.active || 'USD';
    q('.fall-product-price').textContent = (variant ? '' : 'From ') + new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format((variant ? variant.price : product.price_min)/100);
  }
  function photo(src, index) {
    const img = q('.fall-product-image');
    const url = new URL(src, location.origin); url.searchParams.set('width','900');
    img.src = url.href; img.alt = product.title + ' — photo ' + (index+1);
    q('.fall-product-thumbs').querySelectorAll('button').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
  }
  async function open(link) {
    opener = link; const token = ++request; product = null;
    q('#jmt-fall-product-title').textContent = link.textContent.trim() || 'Product details';
    q('[data-status]').textContent = 'Loading product…';
    q('.fall-product-fit').hidden = true; q('.fall-product-price').textContent = '';
    q('.fall-product-image').removeAttribute('src'); q('.fall-product-image').alt = '';
    q('.fall-product-description').textContent = ''; q('.fall-product-thumbs').replaceChildren();
    q('.fall-product-full').href = link.href;
    panel.showModal(); panel.scrollTop = 0; document.documentElement.classList.add('jmt-fall-product-open');
    q('[data-close]').focus();
    const handle = new URL(link.href).pathname.split('/products/')[1]?.split('/')[0];
    try {
      if (!cache.has(handle)) cache.set(handle, fetch('/products/'+encodeURIComponent(handle)+'.js').then(r=>{if(!r.ok) throw Error();return r.json();}).catch(e=>{cache.delete(handle);throw e;}));
      const data = await cache.get(handle);
      if (token !== request) return;
      product = data;
      q('#jmt-fall-product-title').textContent = data.title.replace(/^Mens Thong Underwear\s*[-–]\s*/i,'');
      q('[data-status]').textContent = '';
      const description = new DOMParser().parseFromString(data.description || '', 'text/html');
      description.querySelectorAll('script,style').forEach(el=>el.remove());
      description.querySelectorAll('p,div,li,h1,h2,h3,h4,br').forEach(el=>el.appendChild(description.createTextNode('\n')));
      q('.fall-product-description').textContent = description.body.textContent.replace(/\n\s*\n/g,'\n\n').trim();
      data.images.forEach((src,index)=>{
        const button = document.createElement('button'); button.type='button'; button.setAttribute('aria-label','Show product photo '+(index+1));
        const img = document.createElement('img'); const url = new URL(src,location.origin);url.searchParams.set('width','120');
        img.src=url.href;img.alt='';img.loading='lazy';img.width=60;img.height=60;
        button.append(img);button.addEventListener('click',()=>photo(src,index));q('.fall-product-thumbs').append(button);
      });
      if(data.images.length) photo(data.images[0],0);
      q('[data-jmt-quickadd]').setAttribute('data-product-handle',handle);
      q('.fall-product-fit').hidden=false; fit();
      window.JMT_FALL_TRACK('jmt:fall_product_view', {
        product_id:String(data.id),product_title:data.title,product_handle:data.handle,
        value:data.price_min/100,source:'fall_product_popup'
      });
    } catch(e) { if(token===request) q('[data-status]').textContent='Could not load the preview. Please use the full product page below.'; }
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('#product-grid a[href*="/products/"]');
    if(!link || event.defaultPrevented || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();open(link);
  });
  q('[data-close]').addEventListener('click',close);
  panel.addEventListener('cancel',e=>{e.preventDefault();close();});
  panel.addEventListener('click',e=>{if(e.target===panel){const r=panel.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
  q('[data-fit-edit]').addEventListener('click',()=>{editing=true;panel.close();window.JMT_QUICK_FIT.open('fall_product',{context:'preference'});});
  window.addEventListener('jmt:quick-fit:closed',()=>{if(editing){editing=false;fit();panel.showModal();q('[data-fit-edit]').focus();}});
  window.addEventListener('jmt:cart:changed',()=>{if(panel.open && q('[data-jmt-quickadd]').classList.contains('jmt-quickadd--added'))q('[data-status]').textContent='Added to cart. Keep exploring or close to return to the collection.';});
})();
